export default __webpack_public_path__ + "static/media/home-1.225f480a.png";